import Header from './components/Header'
import TabelaDeFuncionarios from './components/TabelaDeFuncionarios'

function App() {
  return (
    <div>
      <Header />
      <main className="container-global">
        <TabelaDeFuncionarios />
      </main>
    </div>
  )
}

export default App
